<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <path fill="none" d="M100.516,60.158c-22.994,0-63.846,17.584-63.846,39.275s40.852,39.275,63.846,39.275
      c22.996,0,63.847-17.584,63.847-39.275S123.512,60.158,100.516,60.158z M100.516,128.879c-16.256,0-29.445-13.189-29.445-29.445
      s13.189-29.445,29.445-29.445c16.257,0,29.447,13.189,29.447,29.445S116.773,128.879,100.516,128.879z"/>
    <path class="color" fill="#F45B5B" d="M100.516,50.357c-27.643,0-73.613,21.979-73.613,49.076s45.971,49.076,73.613,49.076
      c27.648,0,73.615-21.979,73.615-49.076S128.164,50.357,100.516,50.357z M100.516,138.709c-22.994,0-63.846-17.584-63.846-39.275
      s40.852-39.275,63.846-39.275c22.996,0,63.847,17.584,63.847,39.275S123.512,138.709,100.516,138.709z"/>
    <path class="color" fill="#F45B5B" d="M100.516,69.988c-16.256,0-29.445,13.189-29.445,29.445s13.189,29.445,29.445,29.445
      c16.257,0,29.447-13.189,29.447-29.445S116.773,69.988,100.516,69.988z M101.16,124.556c-13.84,0-25.061-11.221-25.061-25.062
      c0-13.84,11.22-25.061,25.061-25.061c13.841,0,25.061,11.221,25.061,25.061C126.221,113.335,115.001,124.556,101.16,124.556z"/>
    <circle class="color" fill="#F45B5B" cx="101.16" cy="99.495" r="25.061"/>
  </g>
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon'
}
</script>
